import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@quantum/ui/fonts.css' // self-hosted Inter + JetBrains Mono (no Google Fonts request)
import '@quantum/tokens/tokens.css' // shared design-system CSS variables (:root + [data-theme] hook)
import './theme/obsidian.css' // Tailwind v4 (theme+utilities, без preflight) + токены Obsidian Glass
import './theme/glasswork.css' // --gw-* vars (must load before glasswork.js reads them) + light theme
import '@quantum/ui/components.css' // .qt-* component styles (ConnectionDot, Skeleton, Modal, …)
import './index.css'
import App from './App.jsx'
import { installBlurOnEscape } from './utils/blurOnEscape'
import { initTheme } from './utils/appearance'

initTheme() // set data-theme before first paint
installBlurOnEscape()

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
